<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import IngredientGroup from "./ingredients/IngredientGroup.vue";
import InstructionGroup from "./ingredients/InstructionGroup.vue";
import Multiselect from "@vueform/multiselect/dist/multiselect.vue2.js";
import floppyDisk from "../../../../static/assets/images/floppy-disk.svg";
export default {
  name: "Ingredients",
  components: {
    IngredientGroup,
    InstructionGroup,
    Multiselect,
  },
  data() {
    return {
      floppyDisk,
      timeout: null,
    };
  },
  computed: {
    ...mapGetters({
      ingredientGroups: "recipes/ingredientGroups",
      currentRecipe: "recipes/currentRecipe",
      skillLevelOptions: "recipes/skillLevelOptions",
    }),
    serves: {
      set(value) {
        this.$store.commit(`recipes/setRecipeField`, {
          fieldName: "serves",
          value,
        });
        1;
      },
      get() {
        if (this.currentRecipe.serves) {
          return this.currentRecipe.serves;
        }
        return "";
      },
    },
    minimum_serving: {
      set(value) {
        this.$store.commit(`recipes/setRecipeField`, {
          fieldName: "minimum_serving",
          value,
        });
        1;
      },
      get() {
        if (this.currentRecipe.minimum_serving) {
          return this.currentRecipe.minimum_serving;
        }
        return "";
      },
    },
    maximum_serving: {
      set(value) {
        this.$store.commit(`recipes/setRecipeField`, {
          fieldName: "maximum_serving",
          value,
        });
        1;
      },
      get() {
        if (this.currentRecipe.maximum_serving) {
          return this.currentRecipe.maximum_serving;
        }
        return "";
      },
    },
    prep_time: {
      set(value) {
        this.$store.commit(`recipes/setRecipeField`, {
          fieldName: "prep_time",
          value,
        });
        1;
      },
      get() {
        if (this.currentRecipe.prep_time) {
          return this.currentRecipe.prep_time;
        }
        return "";
      },
    },
    cook_time: {
      set(value) {
        this.$store.commit(`recipes/setRecipeField`, {
          fieldName: "cook_time",
          value,
        });
        1;
      },
      get() {
        if (this.currentRecipe.cook_time) {
          return this.currentRecipe.cook_time;
        }
        return "";
      },
    },
    skill_levels: {
      set(value) {
        this.$store.commit(`recipes/setRecipeField`, {
          fieldName: "skill_levels",
          value,
        });
        1;
      },
      get() {
        if (this.currentRecipe.skill_levels) {
          return this.currentRecipe.skill_levels;
        }
        return "";
      },
    },
  },
  methods: {
    addIngredientGroup() {
      this.$store.commit("recipes/addIngredientGroupToCurrentRecipe");
      const id =
        "ingredient_" +
        this.currentRecipe.ingredient_groups[
          this.currentRecipe.ingredient_groups.length - 1
        ].id;

      setTimeout(() => {
        window.document.getElementById(id).focus();
      }, 1);
    },
    addInstructionGroup() {
      this.$store.commit("recipes/addInstructionGroupToCurrentRecipe");
      const id =
        "instruction_" +
        this.currentRecipe.instruction_groups[
          this.currentRecipe.instruction_groups.length - 1
        ].id;

      setTimeout(() => {
        window.document.getElementById(id).focus();
      }, 1);
    },
    selectSkills($e) {
      this.skill_levels = $e;
      this.updateRecipe();
    },
    updateRecipeKeyup() {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.updateRecipe();
      }, 1000);
    },
    updateRecipe() {
      this.$store.dispatch("recipes/updateRecipe", this.$route.params.id).then(
        (res) => {
          this.$store.commit(`commons/setSavingForm`, "Saved");
          this.$store.commit(`recipes/setTabStatus`, false);
        },
        (error) => {
          console.log(error);
        }
      );
    },

    updateRecipeClick() {
      this.$store.commit("commons/setPreloader", true);
      this.$store.dispatch("recipes/updateRecipe", this.$route.params.id).then(
        (res) => {
          this.$store.commit(`commons/setSavingForm`, "Saved");
          this.$store.commit(`recipes/setTabStatus`, false);
          this.$store.commit("commons/setPreloader", false);
        },
        (error) => {
          console.log(error);
        }
      );
    },
    updateMinServing() {
      console.log(this.serves);
    },
    updateMaxServing() {
      console.log(this.serves);
    },
    makeToast(variant = null, title, message) {
      this.$bvToast.toast(message, {
        title: `${title || "default"}`,
        variant: variant,
        solid: true,
        toaster: "b-toaster-bottom-right",
      });
    },
    ingredientGroupsBtn() {
      if (this.currentRecipe.ingredient_groups.length !== 0) {
        return this.currentRecipe.ingredient_groups[
          this.currentRecipe.ingredient_groups.length - 1
        ].status;
      }
      return "";
    },
    instructionGroupsBtn() {
      if (this.currentRecipe.instruction_groups.length !== 0) {
        return this.currentRecipe.instruction_groups[
          this.currentRecipe.instruction_groups.length - 1
        ].status;
      }
      return "";
    },
  },
};
</script>
<style scoped>
h1 {
  font-size: 1.5em;
}
.picker,
.headers,
.groups {
  padding: 20px 40px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 83px;
}
.picker {
  background-color: #fafafb;
}
.item-group {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
}
.picker label {
  text-transform: uppercase;
}
.add-ingredient-group,
.add-instruction-group {
  border-style: dashed;
  text-transform: uppercase;
}
</style>
<template>
  <div class="wrapper">
    <div class="headers">
      <div class="item">
        <h1>Ingredients</h1>
      </div>
      <div class="item">
        <h1>Method</h1>
      </div>
    </div>
    <div class="picker">
      <div class="item-group">
        <div class="item">
          <label>Serves</label>
          <b-form-input
            type="number"
            @keyup="updateRecipeKeyup"
            v-model="serves"
          ></b-form-input>
        </div>
        <div class="item">
          <label>Min. Servings</label>
          <b-form-input
            type="number"
            @keyup="updateRecipeKeyup"
            v-model="minimum_serving"
          ></b-form-input>
        </div>
        <div class="item">
          <label>Max. Servings</label>
          <b-form-input
            type="number"
            @keyup="updateRecipeKeyup"
            v-model="maximum_serving"
          ></b-form-input>
        </div>
      </div>

      <div class="item-group">
        <div class="item">
          <label>Prep Time (Min)</label>
          <b-form-input
            type="number"
            @keyup="updateRecipeKeyup"
            v-model="prep_time"
          ></b-form-input>
        </div>
        <div class="item">
          <label>Cook Time (Min)</label>
          <b-form-input
            type="number"
            @keyup="updateRecipeKeyup"
            v-model="cook_time"
          ></b-form-input>
        </div>
        <div class="item">
          <label>Skill Level</label>
          <multiselect
            v-model="skill_levels"
            :options="skillLevelOptions"
            label="text"
            track-by="text"
            @change="selectSkills"
          >
            <template v-slot:singlelabel="{ value }">
              <div class="multiselect-single-label" v-if="value">
                {{ value.text }}
              </div>
            </template>
          </multiselect>
        </div>
      </div>
    </div>
    <div class="groups">
      <div class="item">
        <ingredient-group
          v-for="item of currentRecipe.ingredient_groups"
          :key="item.id"
          :group="item"
        ></ingredient-group>
        <div class="auto-add-group">
          <b-button
            variant="outline-success"
            class="add-ingredient-group"
            block
            @click="addIngredientGroup"
            :disabled="ingredientGroupsBtn() == 'create'"
            >Add Ingredient Group</b-button
          >
        </div>
      </div>
      <div class="item">
        <instruction-group
          v-for="item of currentRecipe.instruction_groups"
          :key="item.id"
          :group="item"
        ></instruction-group>
        <div class="auto-add-group">
          <b-button
            variant="outline-success"
            class="add-instruction-group"
            block
            @click="addInstructionGroup"
            :disabled="ingredientGroupsBtn() == 'create'"
            >Add Instruction Group</b-button
          >
        </div>
      </div>
    </div>
    <button class="floating-btn btn no-outline" @click="updateRecipeClick()">
      <span class="d-flex justify-content-center align-items-center">
        <img :src="floppyDisk" />
      </span>
    </button>
  </div>
</template>